import { formatActionType } from 'app/dealer/shared/higherOrderReducers/withDataRequest/actionTypeFormatters';

import { LISTINGS_BENCHMARK_REDUCER_NAME } from '../constants';

export const YEARLY_OVERVIEW_PREFIX = 'yearlyOverview';

export const ListingsBenchmarkTopListingsActionTypes = {
  GET_TOP_LISTINGS_DATA_SUCCESS: `[${formatActionType(
    LISTINGS_BENCHMARK_REDUCER_NAME,
  )} Top Listings] SUCCESS`,
  GET_TOP_LISTINGS_DATA_ERROR: `[${formatActionType(
    LISTINGS_BENCHMARK_REDUCER_NAME,
  )} Top Listings] ERROR`,
  SET_ACTIVE_TOP_LISTINGS_CATEGORY: `[${formatActionType(
    LISTINGS_BENCHMARK_REDUCER_NAME,
  )} Top Listings] SET ACTIVE CATEGORY`,
  CLICK_TOP_LISTINGS_CAR_TILE: `[${formatActionType(
    LISTINGS_BENCHMARK_REDUCER_NAME,
  )} Top Listings] CLICK TOP LISTINGS CAR TILE`,
  TOGGLE_CATEGORY_DROPDOWN: `[${formatActionType(
    LISTINGS_BENCHMARK_REDUCER_NAME,
  )} Top Listings] TOGGLE CATEGORY DROPDOWN`,
};

// general
export const TOP_LISTINGS_CACHE_PREFIX = 'topListings';

// #region top listings categories
export const TOP_LISTINGS_CATEGORIES = {
  byFavourites: 'byFavourites',
  byViews: 'byViews',
  byLeads: 'byLeads',
};

export const TOP_LISTINGS_OPTIONS = {
  leads: {
    label: 'Kundenanfragen',
    value: TOP_LISTINGS_CATEGORIES.byLeads,
    prop: TOP_LISTINGS_CATEGORIES.byLeads,
  },
  favourites: {
    label: 'Favoritenanzahl',
    value: TOP_LISTINGS_CATEGORIES.byFavourites,
    prop: TOP_LISTINGS_CATEGORIES.byFavourites,
  },
  views: {
    label: 'Inserataufrufe',
    value: TOP_LISTINGS_CATEGORIES.byViews,
    prop: TOP_LISTINGS_CATEGORIES.byViews,
  },
};
// #endregion top listings categories
